import { Link } from 'react-router-dom';
import { Section } from '../layout/Section';
import { Logo } from '../nav/Logo';
import { Icon } from '../ui/Icon';
import { company, socials } from '../../data/company';
import { footerColumns } from '../../data/nav';
import { useInViewOnce } from '../../hooks/useInViewOnce';
import styles from './Footer.module.css';

export function Footer() {
  const [gridRef, gridIn] = useInViewOnce();

  return (
    <footer className={styles.footer}>
      <Section as="div" spacing="tight">
        <div ref={gridRef} className={`${styles.grid} ${gridIn ? styles.gridIn : ''}`}>
          <div className={styles.brand}>
            <Logo />
            <p className={`${styles.blurb} u-body-lg`}>{company.tagline}</p>
            <ul className={styles.socials}>
              {socials.map((s) => (
                <li key={s.id}>
                  <a className={styles.social} href={s.href} aria-label={s.label}>
                    <Icon name={s.icon} size={20} />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {footerColumns.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h2 className={styles.colTitle}>{col.title}</h2>
              <ul className={styles.colList}>
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link className={styles.colLink} to={link.to}>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
      </Section>

      <div className="container">
        <p className={styles.bottom}>© Nimblepark. All Rights Reserved.</p>
      </div>
    </footer>
  );
}
